import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Clock } from "lucide-react";

/* Shown to self-registered banks until an Admin approves the account. */
export default function BankPendingCard({ feature }) {
  return (
    <Card className="border border-amber-200 bg-amber-50/60 mb-6 max-w-2xl" data-testid="bank-pending-card">
      <CardContent className="p-5 flex items-start gap-3">
        <div className="h-10 w-10 rounded-md bg-amber-100 text-amber-800 flex items-center justify-center flex-shrink-0"><Clock className="h-5 w-5" /></div>
        <div>
          <div className="text-[11px] font-bold uppercase tracking-widest text-amber-800">Awaiting admin approval</div>
          <p className="text-sm text-amber-950 mt-1">
            {feature ? `${feature} unlock once Rana Associates approves your Bank/NBFC account.` : "Your Bank/NBFC account is under review by Rana Associates."}{" "}
            Until then you can view your dashboard and keep your <Link to="/bank/profile" className="underline underline-offset-2 font-medium">profile</Link> up to date — creating leads and opening documents are locked.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
